import { ActiveTab } from 'components/templates/rn/DetailBuildingLayout'

import DocumentMenu from '../DocumentMenu'
import InstructionMenu from '../MenuInstruction'

import CommentTab from './CommentTab'

type Props = {
  activeTab: ActiveTab
  handleCollapse: () => void
}

export default function MenuRightDetailBuilding({
  activeTab,
  handleCollapse
}: Props) {
  return (
    <div className="h-full grid grid-rows-[1fr]">
      {activeTab === '360' && (
        <InstructionMenu
          handleBack={undefined}
          selectedFolder={{
            doc: { id: 1, isFileHolder: true, label: '', children: null }
          }}
        />
      )}

      {activeTab === 'document' && <DocumentMenu />}

      {activeTab === 'comment' && (
        <CommentTab handleCollapse={handleCollapse} />
      )}
    </div>
  )
}
